import React from 'react';

const FAQs = () => {
  return (
    <main className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
      <section className="max-w-4xl mx-auto py-12">
        <h1 className="text-4xl font-extrabold text-indigo-800 text-center mb-6">Frequently Asked Questions</h1>
        <p className="text-lg text-gray-700 text-center mb-10">
          Here are some common questions we receive about our programs, courses, and community. If you have more questions, feel free to reach out!
        </p>

        <div className="space-y-8">
          <div className="bg-white p-6 rounded-xl shadow-md">
            <h2 className="text-xl font-semibold text-indigo-700 mb-2">What is EmpowerHer?</h2>
            <p className="text-gray-600">
              EmpowerHer is a community-driven initiative aimed at equipping women with the tools, resources, and support they need to thrive in their personal and professional lives. Our programs focus on skill development, mentorship, and networking opportunities to help women achieve their goals.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default FAQs;
